// ReservationMulitplePayModal.js
import '../../Assets/Styles/register.css';
import React from "react";
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';

import { Button } from 'primereact/button'; 
import { Dialog } from 'primereact/dialog';
import { InputText } from 'primereact/inputtext';
import { InputMask } from 'primereact/inputmask';
import { InputTextarea } from 'primereact/inputtextarea';
import { Checkbox } from 'primereact/checkbox';
import { Dropdown } from 'primereact/dropdown';
import { Divider } from 'primereact/divider';
import { Panel } from 'primereact/panel';
import { Password } from 'primereact/password';
import { ProgressSpinner } from 'primereact/progressspinner';
import { Skeleton } from 'primereact/skeleton';
import { Message } from 'primereact/message';
import { Menu } from 'primereact/menu';
import { SpeedDial } from 'primereact/speeddial';
import { Toast } from 'primereact/toast';
import { InputSwitch } from 'primereact/inputswitch';
import { TabView, TabPanel } from 'primereact/tabview';

import moment from "moment";
import 'moment/locale/pt-br';

import Box from '@mui/material/Box';
import Grid from '@mui/material/Grid';

// Load Actions
import * as AppActions from '../../Store/Actions/App';
import * as ReservationActions from '../../Store/Actions/Reservation';
import * as OrderActions from '../../Store/Actions/Order';

import visa_icon from '../../Assets/Images/visa_icon.svg';
import mastercard_icon from '../../Assets/Images/mastercard_icon.svg';
import creditcard_icon from '../../Assets/Images/creditcard_icon.svg';
import iconResponsibleWarning from '../../Assets/Images/iconResponsibleWarn.svg';


import {
  maskCreditcard,
  maskCardExpiry,
  maskCPF,
  getCardBrand,
  validarNumeroCartao,
  validarNomeCartao,
  validarValidadeCartao,
  formatNumberCurrency
} from '../../Components/Utils';


// Set main array
const itemsList = [
    {
        label: 'Ações disponíveis',
        items: [
            { label: 'Aprovar cadastro', icon: 'pi pi-check green', command: () => { console.log("OK"); } },
            { label: 'Reprovar cadastro', icon: 'pi pi-ban red', command: () => { console.log("OK"); } },
            { label: 'Colocar em análise', icon: 'pi pi-info orange', command: () => { console.log("OK"); } },
            { label: 'Excluir cadastro', icon: 'pi pi-times', command: () => { console.log("OK"); } }
        ]
    }
];	

// UpdateService dialog component
const ReservationMuliPayView = (props) => {

// set vars from props
const { 
    dialog,
    setDialog,

    setAlert,
    setAlertTitle,
    setAlertBody,

    selectedReservation,

    retrieveMultipleReservations,
    onReloadDataList,
    selectedBookingsStore,
    reservationData = {},            // << recebido do pai (obrigatório)
    payMultipleBooking,                      // já existe em Order.js
    resetSelection,                     // << recebido do pai (obrigatório)
    key
} = props;		


const isOpen = (dialog.target == 'reservationMultiPayModal' && dialog.status);

// Loaders
const [loading, setLoading] = React.useState(true); 
const [saving, setSaving] = React.useState(false); 
const [loadingData, setLoadingData] = React.useState(true); 

// Reservation Data
const [companyLegalName, setCompanyLegalName] = React.useState('');
const [companyFantasyName, setCompanyFantasyName] = React.useState('');
const [companyEmail, setCompanyEmail] = React.useState('');
const [companyPhone, setCompanyPhone] = React.useState('');
const [companyState, setCompanyState] = React.useState('');
const [companyCity, setCompanyCity] = React.useState('');
const [personCompanyName, setPersonCompanyName] = React.useState('');

const [acceptTerm, setAcceptTerm] = React.useState(false);

const [navigationOption, setNavigationOption] = React.useState(null);

// Status control to reflect interface
const [bookingStatus, setBookingStatus] = React.useState(1); // 0 - waiting confirmation | 1 - confirmed | 2 - cancelled by system | 3 - cancelled by agency
const [paymentStatus, setPaymentStatus] = React.useState(0); // 0 - waiting confirmation | 1 - Payment confirmed | 2 - Waiting Refund	| 3 - Refund confirmed
const [cancelStatus, setCancelStatus] = React.useState(0); // 0 - no payment | 1 - payment and cancel within limite date | 2 - payment and cancel after limite date / within provider date | 3 - payment and cancel after provider date | 4 - Cancel after checkin date
const [refundStatus, setRefundStatus] = React.useState(0); // 0 - no refund | 1 - refund generated and waiting refund | 2 - refund generated and paid | 3 - refund created manually and waiting refund | 4 - refund created manually and paid
const [comissionStatus, setComissionStatus] = React.useState(0); // 0 - comission estimatimated, no payment yet | 1 - booking paid, commission generated and waiting payment | 2 - booking paid, commission generated and paid | 3 - No comission, booking paid, antecipated | 4 - Comission cancelled due to booking cancel | 5 - Comission refund due, agency need to pay end customer (booking cancelled after comission beign paid)
 
const [paymentMethod, setPaymentMethod] = React.useState("cc"); // cc - credit card | bcc - business credit card | pix - pix  | other
const [paymentManualConfirmation, setPaymentManualConfirmation] = React.useState(0); // 0 - no confirmation | 1 - manual confirmation
const [checkinDate, setCheckinDate] = React.useState(new Date());

// Set menu control and itens
const [menuItems, setMenuItems] = React.useState(itemsList); // Menu actions Items
const [navigationOptionsShortcut, setNavigationOptionsShortcut] = React.useState([]);

// Interface control
const [bookingHistoryPanel, setBookingHistoryPanel] = React.useState(false);
const [paymentHistoryPanel, setPaymentHistoryPanel] = React.useState(false);
const [bookingHistory, setBookingHistory] = React.useState([]);
const [paymentHistory, setPaymentHistory] = React.useState([]);
const [loadingQuote, setLoadingQuote] = React.useState(false);

const [paymentResponsibleHistory, setPaymentResponsibleHistory] = React.useState([]);
const [paymentResponsibleHistoryPanel, setPaymentResponsibleHistoryPanel] = React.useState(false);

// Dados crus da API para usarmos na tela
const [reservation, setReservation] = React.useState(null);

// [MULTI] lista de reservas retornadas e totais agregados
const [multiReservations, setMultiReservations] = React.useState([]);
const [multiTotals, setMultiTotals] = React.useState(null);

// Conveniências já “derivadas” do payload
const reservationAll = reservation || null;
const booking = reservation?.booking || null;
const latestPayment = reservation?.latestPayment || null;
const refund = reservation?.refund || null;
const totals = reservation?.totals || null;
const responsiblePayer = reservation?.responsiblePayer || null;
const guests = reservation?.guests || [];
const hotel = reservation?.hotel || null;
const history = (booking?.history ?? []);
const historyPayment = (latestPayment?.history ?? []).slice().reverse();
const comission = reservation?.commission || null;

const toast = React.useRef(null);

// Mapeamento das marcas para os ícones
const cardIcons = {
  visa: visa_icon,
  mastercard:mastercard_icon,
  creditcard: creditcard_icon,
  amex: creditcard_icon,
  elo: creditcard_icon,
  hipercard: creditcard_icon,
  diners: creditcard_icon,
  discover: creditcard_icon
};

// ------------ dados base vindos da reserva / múltiplas ------------
// id “base” só é usado pela rotina de pagamento atual (single); não mexemos agora
const id =
  selectedReservation?.reservationId ||
  reservationData?.id;

// [MULTI] prefira câmbio/total vindos do endpoint de múltiplas, quando existir
const usdRate = Number(
  (multiTotals?.payNowConvertedExchangeRate) ??
  (reservationData?.exchangeRates?.usd?.value) ??
  (reservationData?.totals?.payNowConvertedExchangeRate) ??
  5.0
);

const payNowUSD = Number(
  (multiTotals?.payNow) ??
  (reservationData?.totals?.payNow) ??
  0
);

const methodDefaultLabel = reservationData?.latestPayment?.methodLabel || 'Cartão de crédito';

// comissão: usa o que vier da reserva
const commissionDefaultPct = Number(
  reservationData?.commission?.advanceComissionPercentage ??
  reservationData?.commission?.percentage?.cc ??
  0
);

const payer = (reservation?.responsiblePayer || reservationData?.responsiblePayer || {});
const payerCPF = payer?.document?.type === 'CPF' ? payer?.document?.number : '';

// ------------ estados da interface ------------
const [activeIndex, setActiveIndex] = React.useState(0); // 0: cartão | 1: pix (desabilitado)

const [advanceComission, setAdvanceComission] = React.useState(false);
const [advanceComissionPercentage, setAdvanceComissionPercentage] = React.useState(commissionDefaultPct);
const [advanceComissionAmountUSD, setAdvanceComissionAmountUSD] = React.useState(0);

const [installmentsOptions, setInstallmentsOptions] = React.useState([]);
const [form, setForm] = React.useState({
  cardNumber: '',
  cardBrand: 'creditcard',
  cardHolderName: '',
  cardExpiry: '',
  cardCvv: '',
  cardHolderCpf: payerCPF || '',
  installments: null,
  installmentsLabel: null
});

// ------------ helpers ------------
const normalizeDigits = (v = '') => String(v).replace(/\D/g, '');
const normalizeCard = (v = '') => String(v).replace(/\s+/g, '');

const toTitle = (s='') => s ? s.charAt(0).toUpperCase() + s.slice(1).toLowerCase() : s;
const mapBrandForApi = (raw) => {
  const b = String(raw || '').toLowerCase();
  const map = { visa:'Visa', mastercard:'Master', amex:'Amex', elo:'Elo', hipercard:'Hipercard', diners:'Diners', discover:'Discover', creditcard:'Unknown' };
  return map[b] || toTitle(b);
};

const computeInstallments = (useUSD) => {
  const minimumPerInstallmentUSD = 25;
  const opts = [];
  for (let i = 1; i <= 12; i++) {
      const per = useUSD / i;
      if (per >= minimumPerInstallmentUSD) {
      const perBRL = per * usdRate;
      opts.push({
          label: `${i}x sem juros de ${formatNumberCurrency(perBRL, 'BRL')}`,
          value: i
      });
      }
  }
  setInstallmentsOptions(opts);
  setForm((p) => ({ ...p, installments: null, installmentsLabel: null }));
};

// [MULTI] render de um card-resumo por reserva
const renderMiniReservationCard = (r, idx) => {
  if (!r) return null;
  const periodDisplay = r?.booking?.period?.display || '-';
  const destDisplay   = r?.destination?.display || '-';
  const hotelName     = r?.hotel?.name || '-';
  const totalUSD      = Number(r?.totals?.payNow ?? 0);
  const totalUSDDisp  = formatNumberCurrency(totalUSD, 'USD');
  const totalBRLEst   = usdRate ? formatNumberCurrency(totalUSD * usdRate, 'BRL') : null;

  return (
    <div key={r.id || idx} className="bookingMiniCard w100"
         style={{ border:'1px solid #eee', borderRadius:'12px', padding:'12px', marginBottom:'10px', background:'#fff' }}>
      <div className="flex-row justify-between align-items-center" style={{ marginBottom: 6 }}>
        <div className="bookingDetails_title" style={{ fontWeight: 600 }}>
          #{r.id || '-'} — {hotelName}
        </div>
        {r?.latestPayment?.statusLabel && (
          <div style={{ fontSize:12, color:'#666' }}>{r.latestPayment.statusLabel}</div>
        )}
      </div>

      <div className="flex-column" style={{ gap:'6px' }}>
        <div className="bookingDetails_wrapper_item flex-row justify-between align-items-center w100" style={{gap:"1rem"}}>
          <div className="bookingDetails_wrapper_item_label">Destino</div>
          <div className="bookingDetails_wrapper_item_line flex-1"></div>
          <div className="bookingDetails_wrapper_item_value tAlignR">{destDisplay}</div>
        </div>

        <div className="bookingDetails_wrapper_item flex-row justify-between align-items-center w100" style={{gap:"1rem"}}>
          <div className="bookingDetails_wrapper_item_label">Período</div>
          <div className="bookingDetails_wrapper_item_line flex-1"></div>
          <div className="bookingDetails_wrapper_item_value tAlignR">{periodDisplay}</div>
        </div>

        <div className="bookingDetails_wrapper_item flex-row justify-between align-items-center w100" style={{gap:"1rem"}}>
          <div className="bookingDetails_wrapper_item_label">Valor (USD)</div>
          <div className="bookingDetails_wrapper_item_line flex-1"></div>
          <div className="bookingDetails_wrapper_item_value tAlignR">{totalUSDDisp}</div>
        </div>

        {totalBRLEst && (
          <div className="bookingDetails_wrapper_item flex-row justify-between align-items-center w100" style={{gap:"1rem"}}>
            <div className="bookingDetails_wrapper_item_label">Estimativa em BRL</div>
            <div className="bookingDetails_wrapper_item_line flex-1"></div>
            <div className="bookingDetails_wrapper_item_value tAlignR">{totalBRLEst}</div>
          </div>
        )}
      </div>
    </div>
  );
};

// [MULTI] Normaliza dados do responsável (nome, doc, flags) p/ manter compatibilidade do layout
const normalizeResponsible = (rp = {}, guests = []) => {
  if (!rp) return null;

  // ---- Nome completo
  const fullName =
    rp.fullName ||
    rp.completeName ||
    [rp.firstName, rp.lastName].filter(Boolean).join(' ').trim() ||
    null;


  // ---- Candidatos de documento (cobrir diferentes formatos do backend)
  const docCandidates = [
    rp.document,
    rp.Document,
    rp.documents?.[0],
    rp.BookingPaymentResponsibleDocuments?.[0],
    rp.bookingPaymentResponsibleDocuments?.[0],
    (rp.documentType || rp.documentNumber) ? { documentType: rp.documentType, documentNumber: rp.documentNumber } : null,
    rp.CompanyPerson?.CompanyPersonDocuments?.[0]
  ].filter(Boolean);

  let docType = null;
  let docNumber = null;
  let docFormatted = null;

  for (const c of docCandidates) {
    const t = c?.type || c?.documentType || c?.typeName || null;
    const n = c?.number || c?.documentNumber || c?.value || null;
    const f = c?.formattedValue || null;
    if (!docType && t) docType = String(t).toUpperCase();
    if (!docNumber && (n || f)) {
      docNumber = (n || f);
      docFormatted = f || null;
    }
    if (docType && docNumber) break;
  }

  // Se veio só formatado (com máscara), mantém assim; senão mantém "cru"
  const document = (docType || docNumber)
    ? { type: docType, number: String(docNumber || '').trim() }
    : null;

  // ---- Flags
  const isForeigner =
    (rp.isForeigner != null)
      ? rp.isForeigner
      : (docType ? docType !== 'CPF' : null);

  const fullNameLower = (fullName || '').toLowerCase();
  const isOneOfGuests =
    (rp.isOneOfGuests != null)
      ? rp.isOneOfGuests
      : guests.some(g => {
          const gn = [g.firstName, g.lastName].filter(Boolean).join(' ').trim().toLowerCase();
          return gn && fullNameLower && gn === fullNameLower;
        });

  return { ...rp, fullName, document, isForeigner, isOneOfGuests };
};

// [MULTI] Descobre o % de comissão a partir dos campos disponíveis ou por inferência
const deriveCommissionPct = (res) => {
  if (!res) return 0;
  const method = res?.latestPayment?.method || 'cc';

  // 1) tentativas diretas
  const direct =
    (method === 'pix'
      ? (res?.commission?.pixPercent ?? res?.commission?.percentage?.pix)
      : (res?.commission?.ccPercent  ?? res?.commission?.percentage?.cc));

  if (direct != null && !isNaN(Number(direct))) {
    return Number(direct);
  }

  // 2) inferência via valores estimados (convertidos)
  const usdRateLocal = Number(
    res?.totals?.payNowConvertedExchangeRate ??
    res?.exchangeRates?.usd?.value ??
    (usdRate || 0)
  );

  const totalUSD = Number(res?.totals?.payNow ?? 0);
  const totalBRL = totalUSD * (usdRateLocal || 0);

  const estBRL = (method === 'pix'
    ? Number(res?.commission?.estimated?.comissionConvertedAmountPIX ?? 0)
    : Number(res?.commission?.estimated?.comissionConvertedAmountCC  ?? 0)
  );

  if (totalBRL > 0 && estBRL > 0) {
    return Math.round((estBRL / totalBRL) * 10000) / 100; // 2 casas
  }

  // 3) fallback
  return 0;
};



const totalUSD = payNowUSD || 0;
const commissionUSD = (totalUSD * (advanceComissionPercentage || 0)) / 100;
const totalUSDNoCommission = Math.max(totalUSD - commissionUSD, 0);

const totalBRL = totalUSD * usdRate;
const totalBRLNoCommission = totalUSDNoCommission * usdRate;
const commissionBRL = commissionUSD * usdRate;

// recomputa comissão quando muda toggle/pct
React.useEffect(() => {
  setAdvanceComissionAmountUSD(commissionUSD);
}, [advanceComission, advanceComissionPercentage, totalUSD]);

// Recalcula parcelas quando os parâmetros relevantes mudarem
React.useEffect(() => {
  const baseUSD = advanceComission ? totalUSDNoCommission : totalUSD;
  computeInstallments(baseUSD);
  // eslint-disable-next-line react-hooks/exhaustive-deps
}, [advanceComission, advanceComissionPercentage, totalUSD, usdRate]);

const handleField = (k, v) => setForm((p) => ({ ...p, [k]: v }));

const resetState = () => {
  setActiveIndex(0);
  setLoading(false);
  setAdvanceComission(false);
  setAdvanceComissionPercentage(commissionDefaultPct);
  setAdvanceComissionAmountUSD(0);
  setInstallmentsOptions([]);
  setForm({
    cardNumber: '',
    cardBrand: 'creditcard',
    cardHolderName: '',
    cardExpiry: '',
    cardCvv: '',
    cardHolderCpf: payerCPF || '',
    installments: null,
    installmentsLabel: null
  });
};

const close = () => {
    resetState();
    setDialog("reservationMultiPayModal",false);
};

React.useEffect(() => {
  if (!isOpen) resetState();
  if (isOpen) {
      const baseUSD = advanceComission ? totalUSDNoCommission : totalUSD;
      computeInstallments(baseUSD);

    setForm(p => ({
        ...p,
        cardNumber: '',
        cardBrand: 'creditcard',
        cardHolderName: '',
        cardExpiry: '',
        cardCvv: '',
        cardHolderCpf: payerCPF || '',
        installments: null,
        installmentsLabel: null
    }));

  }
}, [isOpen]);

React.useEffect(() => {

    setForm(p => ({
        ...p,
        cardNumber: '',
        cardBrand: 'creditcard',
        cardHolderName: '',
        cardExpiry: '',
        cardCvv: '',
        cardHolderCpf: payerCPF || '',
        installments: null,
        installmentsLabel: null
    }));
  
}, [payerCPF]);


// cria um voucher básico (igual ao seu)
const buildVoucherInfo = (r) => {

  if (!r) return null;

  const reservationData2 = r;

  const room0 = reservationData2?.hotel?.rooms?.[0] || {};
  const hotel = reservationData2?.hotel || {};
  const dest = reservationData2?.destination || {};
  const totals = reservationData2?.totals || {};
  const period = reservationData2?.booking?.period || {};
  const payer = reservationData2?.responsiblePayer || {};

  const bookingNumber =
      reservationData2?.booking?.reservationCode ||
      reservationData2?.internalCode ||
      String(reservationData2?.id || '');

  const deadlineDisplay =
      reservationData2?.booking?.deadlines?.freeCancelDateDisplay ||
      room0?.cancelPolicy?.untilDisplay ||
      '—';

  const guestsLabel =
      room0?.guestsSummary ||
      (Array.isArray(reservationData2?.guests) && reservationData2.guests.length
      ? `${reservationData2.guests.length} hóspedes`
      : '—');

  const roomExtra =
      Array.isArray(room0?.extras) && room0.extras.length
      ? room0.extras.join(', ')
      : 'Nenhum extra incluído';

  return {
      hotel_name: `${hotel?.name || ''}${dest?.display ? ` - ${dest.display}` : ''}`.trim() || '—',
      booking_period: period?.display || '—',
      booking_number: bookingNumber,
      hotel_address: [hotel?.address, dest?.city].filter(Boolean).join(', ') || '—',
      hotel_contact: { tel: '', email: '', site: '' },
      hotel_checkin: hotel?.checkinTime || '15:00:00',
      hotel_checkout: hotel?.checkoutTime || '12:00:00',
      cancellation_deadline: deadlineDisplay,
      cancellation_policy: room0?.cancelPolicy?.text || '- não definido -',
      total_amount: totals?.displayTotal || totals?.payNowDisplay || '0',
      total_booking: totals?.payNowDisplay || totals?.displayTotal || '0',
      total_local: totals?.payAtPropertyDisplay || '0',
      room: {
          title: room0?.name || '- não definido -',
          room_name: room0?.name || '- não definido -',
          room_hosts_label: guestsLabel || '- não definido -',
          room_responsible_name: payer?.completeName || '- não definido -',
          room_extra: roomExtra || '- não definido -'
      },
      bookingPaymentResponsible: {
          completeName: payer?.completeName || '- não definido -',
          email: payer?.email || '- não definido -',
          mobilePhone: payer?.mobilePhone || '- não definido -'
      }
  };
};

const buildBookingsList = () => {

    if (!Array.isArray(multiReservations) || !multiReservations.length) {
        return id ? [Number(id)] : [];
    }

    return multiReservations.map(r => {

        const pct = Number(advanceComissionPercentage || 0);

        const payNowUSD = Number(r?.totals?.payNow ?? 0);
        const usdRate = Number(
            (r?.totals?.payNowConvertedExchangeRate) ??
            (r?.exchangeRates?.usd?.value) ?? 1
        );

        // Total (USD/BRL) — agora vindo da soma, se múltiplas
        const totalUSD = payNowUSD || 0;
        const totalBRL = totalUSD * usdRate;

        const commissionUSD = (totalUSD * pct) / 100;
        const commissionBRL = commissionUSD * usdRate;

        const chargeUSD = advanceComission ? Math.max(totalUSD - commissionUSD, 0) : totalUSD;
        const chargeBRL = chargeUSD * usdRate;        

        return {
            id: Number(r.id || 0),
            bookingId: Number(r.id || 0),
            payment: {
                originalAmount: totalUSD.toFixed(2),
                originalCurrency: 'USD',
                exchangeRateUsed: usdRate,
                convertedCurrency: 'BRL',
                amount: chargeBRL.toFixed(2),
                advanceCommission: !!advanceComission,
                comissionAmount: commissionUSD.toFixed(2),
                comissionAmountCalculated: commissionBRL.toFixed(2),
                comissionPercentage: pct,
            },
            bookingVoucherInfo: buildVoucherInfo(r)
        };

    });

};

// ------------ ação principal (pagar) ------------
// (mantida do seu componente, sem alterações funcionais)
const handlePay = async () => {

  try {

    if (activeIndex !== 0) {
      toast.current?.show({ severity: 'warn', summary: 'Forma indisponível', detail: 'PIX em breve. Use Cartão de crédito.', life: 6000 });
      return;
    }
    // validações
    const numberRaw = normalizeCard(form.cardNumber);
    const holderRaw = (form.cardHolderName || '').trim();
    const expRaw = (form.cardExpiry || '').trim();
    const cvvRaw = normalizeDigits(form.cardCvv);
    const cpfRaw = normalizeDigits(form.cardHolderCpf);

    if (!validarNumeroCartao(numberRaw)) {
      toast.current?.show({ severity: 'warn', summary: 'Cartão', detail: 'Número do cartão inválido.', life: 6000 });
      return;
    }
    if (!validarNomeCartao(holderRaw)) {
      toast.current?.show({ severity: 'warn', summary: 'Cartão', detail: 'Nome do portador inválido.', life: 6000 });
      return;
    }
    if (!validarValidadeCartao(expRaw)) {
      toast.current?.show({ severity: 'warn', summary: 'Cartão', detail: 'Validade inválida. Use MM/AA ou MM/AAAA.', life: 6000 });
      return;
    }
    if (!cvvRaw || cvvRaw.length < 3) {
      toast.current?.show({ severity: 'warn', summary: 'Cartão', detail: 'CVV inválido.', life: 6000 });
      return;
    }
    if (!form.installments) {
      toast.current?.show({ severity: 'warn', summary: 'Parcelamento', detail: 'Selecione o número de parcelas.', life: 6000 });
      return;
    }
    if (payer?.isForeigner !== true && !cpfRaw) {
      toast.current?.show({ severity: 'warn', summary: 'Documento', detail: 'Informe o CPF do portador.', life: 6000 });
      return;
    }

    // bandeira
    const detected = getCardBrand(numberRaw);
    const brandApi = mapBrandForApi(detected);

    // 4.1) Verificsa se a bandeira do cartão é aceita
    const acceptedCreditcardBrands = ['Visa', 'Master'];
    if (!acceptedCreditcardBrands.includes(brandApi)) {
      toast.current?.show({ severity: 'warn', summary: 'Bandeira não aceita', detail: 'Bandeira do cartão não aceita. Confira e tente novamente.', life: 6000 });
      return;
    }       

    // --------- Cálculos de valores ---------
    const pct = Number(advanceComissionPercentage || 0);

    // Total (USD/BRL) — agora vindo da soma, se múltiplas
    const totalUSD = payNowUSD || 0;
    const totalBRL = totalUSD * usdRate;

    const commissionUSD = (totalUSD * pct) / 100;
    const commissionBRL = commissionUSD * usdRate;

    const chargeUSD = advanceComission ? Math.max(totalUSD - commissionUSD, 0) : totalUSD;
    const chargeBRL = chargeUSD * usdRate;

    const payload = {
        customer: {
            name: (payer?.fullName || '').trim(),
            identity: cpfRaw || '',
            email: (payer?.email || '').trim()
        },
        payment: {
            originalAmount: chargeUSD.toFixed(2),
            originalCurrency: 'USD',
            exchangeRateUsed: usdRate,
            convertedCurrency: 'BRL',
            amount: chargeBRL.toFixed(2),
            advanceCommission: !!advanceComission,
            comissionAmount: commissionBRL.toFixed(2),
            comissionAmountCalculated: commissionBRL,
            comissionPercentage: pct,
            paymentMethod: 'cc',
            installments: Number(form.installments || 1),
            creditCard: {
                cardNumber: numberRaw,
                holder: holderRaw,
                expirationDate: expRaw,
                securityCode: cvvRaw,
                brand: brandApi
            }
        },
        bookings: buildBookingsList(), // [MULTI] agora é lista
    };

    setLoading(true);
    const res = await payMultipleBooking(payload);

    if (res?.success) {
      setAlertTitle('Tudo certo! Pagamento de múltiplas reservas realizado!');
      setAlertBody('O pagamento das reservas foi realizado com sucesso! As reservas foram atualizadas com os dados mais recentes. Os vouchers serão enviados por e-mail no email de confirmação.');
      setAlert(true);
      close();

      onReloadDataList();
      resetSelection();
      return;
    }

    if (res?.data?.pending) {
      setAlertTitle('Pagamento pendente');
      setAlertBody(res?.error || 'O pagamento ficou pendente no provedor. Aguarde o processamento e atualize a reserva em alguns minutos.');
      setAlert(true);
      close();

      onReloadDataList();
      resetSelection();
      return;
    }

    const errKey = String(res?.errorKey || res?.details?.errorCode || '');
    const status = res?.status || null;
    const userMsg =
      res?.userMessage ||
      'Não foi possível concluir o pagamento. Tente novamente em instantes.';

    if (status === 409 && (errKey === '40901' || errKey === '40902')) {
        setAlertTitle('Ops! Temos um problema!');
        setAlertBody('O pagmento da reserva mudou de status durante o processo e não é possível prosseguir. Atualizamos as informações da reserva. Verifique e tente novamente, se for o caso.');
        setAlert(true);
        close();

        onReloadDataList();
        resetSelection();
        return;
    }

    toast.current?.show({ severity: 'error', summary: 'Falha no pagamento', detail: userMsg, life: 10000 });

  } catch (err) {
      const status = err?.response?.status || null;
      const code =
      String(err?.response?.data?.errorCode || err?.response?.data?.code || '');
      const userMsg =
      err?.response?.data?.userMessage ||
      err?.response?.data?.errorMessage ||
      err?.message ||
      'Não foi possível concluir o pagamento no momento.';

      if (status === 409 && (code === '40901' || code === '40902')) {
          setAlertTitle('Ops! Temos um problema!');
          setAlertBody('O pagamento da reserva mudou de status durante o processo e não é possível prosseguir. Atualizamos as informações da reserva. Verifique e tente novamente, se for o caso.');
          setAlert(true);
          close();

            onReloadDataList();
            resetSelection();

          return;
      }

      toast.current?.show({ severity: 'error', summary: 'Erro no pagamento', detail: userMsg, life: 10000 });

  } finally {
    setLoading(false);
  }
};


// Reset form fields and close dialog
const closeDialog = () => {
  setDialog('reservationMultiPayModal',false);
}

// Execute when component opens
React.useEffect(() => {
  // Enter and closes modal
  //setDialog('reservationMultiPayModal',false);
},[]);

// Execute when dialog opens
React.useEffect(() => {
  // Only runs when dialog opens
  if (dialog.target == 'reservationMultiPayModal' && dialog.status) {
      // Retrieve reservations (agora multi)
      executeRetrieveOrder();
      setNavigationOption(null);
  }
  return () => {
      setNavigationOption(null);
      setMultiReservations([]);
      setMultiTotals(null);
      setReservation(null);
      setLoadingData(true);
  };	
},[dialog]);

const footerContent = (
  <div className="modalFooterButtons" style={{}}>
    <div className="modalFooterButtonsLeft" style={{height:"50px"}}>
      <div className="flex-row justify-start align-items-center" style={{position:"relative",height:"100%"}} />
    </div>
    <div className="modalFooterButtonsRight">

    <Button label="Fechar" disabled={saving} icon="pi pi-times" className="p-button-text" onClick={() => closeDialog()} />

    <Button
        label={loading ? 'Processando...' : 'Confirmar pagamento'}
        icon={loading ? 'pi pi-spin pi-spinner' : 'pi pi-check'}
        onClick={handlePay}
        disabled={loading || !form.cardNumber || !form.cardHolderName || !form.cardExpiry || !form.cardCvv || (payer?.isForeigner !== true && !form.cardHolderCpf) || !form.installments}
        style={{ maxWidth: "50%" }}
    />

    </div>
  </div>
);	

const headerTemplate = (
  <>
    <div className="flex-row align-items-center justify-start">
      <div className="flex-1">
        <h2 className="m-0" style={{fontSize:"1.2rem",margin:"0"}}>Pagamento único de múltiplas reservas</h2>
      </div>
    </div>
  </>
);


// [MULTI] novo loader: múltiplas reservas
const executeRetrieveOrder = async () => {

  try {
    setLoadingData(true);

    // monta lista de IDs da seleção atual (até 10)
    const bookingIds =
      Array.isArray(selectedBookingsStore)
        ? selectedBookingsStore
            .map((it) => Number(it?.reservationId))
            .filter((v) => Number.isFinite(v) && v > 0)
            .slice(0, 10)
        : [];

    // >>> múltiplas reservas
    const resp = await retrieveMultipleReservations({ bookingIds });

    // aceita tanto {success,data:{reservations,totals}} quanto {reservations,totals}
    const data = resp?.data || resp;
    const list = data?.reservations || data?.data?.reservations || [];
    const groupTotals = data?.totals || data?.data?.totals || null;

    if (!resp?.success || !Array.isArray(list) || list.length === 0) {
      setAlert(true);
      setAlertTitle("Ops! Não foi possível carregar as reservas selecionadas");
      setAlertBody(resp?.error || "Tente novamente em instantes.");
      setLoadingData(false);
      return;
    }

    setMultiReservations(list);
    setMultiTotals(groupTotals);

    // usa a primeira reserva como “referência” para campos já presentes no layout
    const r = list[0];

    //setReservation(r);
    const normalized = normalizeResponsible(r?.responsiblePayer, r?.guests || []);
    const withResp = { ...r, responsiblePayer: normalized };
    setReservation(withResp);

    // % de comissão default (pela 1ª reserva)
    const pct = deriveCommissionPct(withResp);
    setAdvanceComissionPercentage(Number(pct) || 0);

    // Sincroniza estados existentes com base na primeira reserva
    setBookingStatus(Number(r?.booking?.status ?? 0));
    setPaymentStatus(Number(r?.latestPayment?.status ?? 0));
    setCancelStatus(Number(r?.booking?.cancellation?.cancelStatus ?? 0));
    setRefundStatus(Number(r?.refund?.status ?? 0));
    setComissionStatus(Number(r?.commission?.status ?? 0));
    setPaymentMethod(r?.latestPayment?.method || "cc");
    setPaymentManualConfirmation(r?.latestPayment?.manualConfirmation ? 1 : 0);

    if (r?.booking?.period?.checkin) {
      setCheckinDate(new Date(r.booking.period.checkin));
    }

    setBookingHistory(Array.isArray(r?.booking?.history) ? r.booking.history : []);
    setPaymentHistory(Array.isArray(r?.latestPayment?.history) ? r.latestPayment.history : []);
    setPaymentResponsibleHistory(
      Array.isArray(r?.responsiblePayer?.history) ? r.responsiblePayer.history : []
    );

    setLoadingData(false);

  } catch (e) {
    setAlert(true);
    setAlertTitle("Erro inesperado");
    setAlertBody(e?.message || "Tente novamente.");
    setLoadingData(false);
  }
};


return (
  <>
    <Dialog header={headerTemplate} visible={dialog.target == 'reservationMultiPayModal' && dialog.status} style={{ width: '75vw',height:"95vh" }} breakpoints={{ '1360px': '95vw','960px': '90vw', '641px': '100vw' }} onHide={() => closeDialog()} footer={footerContent} maximizable={saving ? false : true} closable={saving ? false : true} closeOnEscape={true} key={key || 'reservation-pay-modal'} >

      <Box sx={{ width: "100%" }}>
        {/* LOADING  */}
        {loadingData &&
          <>
            <div style={{backgroundColor:"transparent", width:"100%",maxWidth:"1170px", marginTop:"30px",marginBottom:"50px",display:"flex",alignItems:"center",justifyContent:"flex-start",flexDirection:"row"}}>
              <ProgressSpinner style={{width: '40px', height: '40px',marginRight: "20px",marginLeft:"20px"}} strokeWidth="4" />
              <div style={{fontSize:"16px",marginTop:"0px"}}> Buscando dados da(s) reserva(s)... </div>
            </div>
            <Skeleton width="100%" height="4rem" ></Skeleton><br />
            <Skeleton width="100%" height="4rem" ></Skeleton><br />
            <Skeleton width="100%" height="4rem" ></Skeleton><br />
            <Skeleton width="100%" height="4rem" ></Skeleton>
          </>
        }

        {/* CONTENT  */}
        {!loadingData &&
          <>
            <div id="topSection" className="navigationContentWrapper flex-row justify-center align-items-start" style={{marginTop:"1rem",width:"100%",flex:1,gap:"1rem"}}>

              <div className="resultsWrapper flex-column justify-center align-items-center" style={{gap:"1rem",flex:1.1}}>

                {/* HOTEL PAYMENT RESPONSIBLE - START */}  						
                <div id="paymentResponsibleData" className="resultsCard flex-row justify-center align-items-stretch w100" style={{gap:"1rem",padding:"2rem",borderRadius: "1.87rem",background: "#FFFFFF"}}>

                  <div className="flex-column justify-center align-items-center" style={{gap:"2rem",flex:1}}>

                    <div className="resultsCard_image" style={{width:"100%",overflow:"hidden",display:"flex",justifyContent:"center",alignItems:"center",position:"relative"}}>

                      <div className="bookingDetails flex-column justify-start align-items-start w100" style={{gap:"0.5rem",padding:"1rem"}}>

                        <div className="bookingDetails_wrapper flex-column justify-center align-items-start" style={{gap:"1rem",maxWidth:"900px"}}>

                            <div className="bookingDetails_title">
                                Dados do responsável pelo pagamento
                            </div>

                          {/* Nome e perfil */}
                          <div className="bookingDetails_wrapper_item flex-row justify-between align-items-center w100" style={{gap:"1rem"}}>
                            <div className="bookingDetails_wrapper_item_label">Nome completo</div>
                            <div className="bookingDetails_wrapper_item_line flex-1"></div>
                            <div className="bookingDetails_wrapper_item_value tAlignR">
                              {responsiblePayer?.fullName || "-"} <br />
                              <small style={{color:"#333"}}>{responsiblePayer?.isForeigner ? "É estrangeiro" : "É brasileiro"}</small><br />
                              <small style={{color:"#333"}}>{responsiblePayer?.isOneOfGuests ? "É um dos hóspedes" : "Não é um dos hóspedes"}</small>
                            </div>
                          </div>

                          {/* Documento */}
                          <div className="bookingDetails_wrapper_item flex-row justify-between align-items-center w100" style={{gap:"1rem"}}>
                            <div className="bookingDetails_wrapper_item_label">Documento</div>
                            <div className="bookingDetails_wrapper_item_line flex-1"></div>
                            <div className="bookingDetails_wrapper_item_value tAlignR">{responsiblePayer?.document?.type && responsiblePayer?.document?.number ? `${responsiblePayer.document.type}: ${responsiblePayer.document.type.toLowerCase() == "cpf" ? maskCPF(responsiblePayer.document.number) : responsiblePayer.document.number}` : "-"}</div>
                          </div>

                        </div>

                      </div>

                    </div> 

                  </div>
                </div> 
                {/* HOTEL PAYMENT RESPONSIBLE - END */}  


                {/* BOOKING SUMMARY START */}  
                <div id="bookingData" className="resultsCard flex-row justify-center align-items-stretch w100" style={{gap:"1rem",padding:"2rem",borderRadius: "1.87rem",background: "#FFFFFF"}}>

                  <div className="flex-column justify-center align-items-center" style={{gap:"2rem",flex:1}}>

                    <div className="resultsCard_image" style={{width:"100%",overflow:"hidden",display:"flex",justifyContent:"center",alignItems:"center",position:"relative"}}>

                      <div className="bookingDetails flex-column justify-start align-items-start w100" style={{gap:"0.5rem",padding:"1rem"}}>
                        
                            {/* [MULTI] título dinâmico (1 reserva ou várias) */}
                            <div className="bookingDetails_title">
                            {multiReservations.length > 1
                                ? `Reservas selecionadas (${multiReservations.length})`
                                : `Reserva selecionada #${reservationAll?.id || selectedReservation?.reservationId || '-'}`
                            }
                            </div>

                            <div className="bookingDetails_wrapper flex-column justify-center align-items-start"
                                style={{gap:"1rem",maxWidth:"900px"}}>

                            {/* [MULTI] cards de resumo — 1 por reserva */}
                            {(multiReservations.length ? multiReservations : [reservationAll])
                                .filter(Boolean)
                                .map((r, idx) => renderMiniReservationCard(r, idx))}
                            </div>


                      </div>

                    </div> 

                  </div>
                </div>
                {/* BOOKING SUMMARY END */}  

              </div>

              <div  style={{flex:1}}>

                <div className="p-fluid" style={{ display: 'flex', flexDirection: 'column', gap: 12 }}>
                  {/* Resumo topo */}
                  <div style={{ background: '#f8f9fa', border: '1px solid #eee', borderRadius: 8, padding: 12 }}>
                    <div style={{ display: 'flex', flexWrap: 'wrap', gap: 12, fontSize: '1rem' }}>
                      <span><strong>Forma de pagamento:</strong> {methodDefaultLabel}</span>
                    </div>
                    <div style={{ marginTop: 8 }}>
                      <div style={{ fontSize: 14 }}>
                        {advanceComission ? (
                          <>
                            <div><strong>Valor total:</strong> {formatNumberCurrency(totalBRLNoCommission, 'BRL')}</div>
                            <div style={{ color: '#b42318', fontWeight: 600 }}>
                              Comissão antecipada: {formatNumberCurrency(commissionBRL, 'BRL')} ({advanceComissionPercentage}%)
                            </div>
                          </>
                        ) : (
                          <div><strong>Valor total:</strong> {formatNumberCurrency(totalBRL, 'BRL')}</div>
                        )}
                        <div style={{ color: '#878787', fontSize: 12 }}>
                          inclui impostos e taxas • câmbio de hoje: {usdRate?.toFixed(2)} BRL/USD
                        </div>
                      </div>
                    </div>
                  </div>

                  {/* Antecipar comissão */}
                  <div className="field" style={{ display: 'flex', alignItems: 'center', gap: 10, marginTop:"0.5rem" }}>
                    <InputSwitch
                        inputId="advanceComission"
                        checked={advanceComission}
                        onChange={(e) => setAdvanceComission(!!e.value)}
                        disabled={loading}
                    />
                    <label htmlFor="advanceComission">
                      Antecipar <strong>{formatNumberCurrency(commissionBRL, 'BRL')}</strong> referente aos <strong>{advanceComissionPercentage || 0}%</strong> de comissão da agência
                    </label>
                  </div>

                  <div className="flex-row justify-content-start align-items-center w100" style={{gap:"1rem",marginTop:"0rem",padding:"0.5rem"}}>
                    <img src={iconResponsibleWarning} alt="Aviso de antecipação de comisssão" style={{width:"2.5rem",height:"auto"}} />
                    <div className="advanceComissionWarningSmall" style={{fontSize:"0.75rem"}}>Ao retirar a comissão da agência do valor final de pagamento a mesma deve ser cobrada pela agência diretamente do cliente final.</div>
                  </div>        

                  {/* Tabs de pagamento */}
                  <TabView activeIndex={activeIndex} onTabChange={(e) => setActiveIndex(e.index)}>
                    <TabPanel header="Cartão de crédito">

                      <Grid container spacing={2} style={{width:"100%",padding:"0.5rem"}}>

                        <Grid item xs={12} sm={6}>
                          {/* Número */}
                          <div className="field" style={{ position: 'relative', flex:1}}>
                            <label>Número do cartão <span className="requiredField">*</span></label>
                            <InputText
                              value={form.cardNumber}
                              onChange={(e) => {
                                  const raw = e.target.value.replace(/\D/g, '');
                                  const masked = maskCreditcard(raw);
                                  handleField('cardNumber', masked);

                                  // detectar bandeira simples
                                  if (/^4/.test(raw)) handleField('cardBrand', 'visa');
                                  else if (/^5[1-5]/.test(raw)) handleField('cardBrand', 'mastercard');
                                  else if (/^3[47]/.test(raw)) handleField('cardBrand', 'amex');
                                  else if (/^6(?:011|5)/.test(raw)) handleField('cardBrand', 'discover');
                                  else handleField('cardBrand', 'creditcard');
                              }}
                              placeholder="**** **** **** ****"
                              maxLength={form.cardBrand === 'amex' ? 18 : 19}
                              disabled={loading}
                              className="w100"
                            />
                            {form.cardBrand && (
                              <img
                                src={cardIcons[form.cardBrand]}
                                alt={form.cardBrand}
                                style={{
                                  position: 'absolute',
                                  right: '15px',
                                  top: '5px',
                                  transform: 'translateY(50%)',
                                  height: '40px',
                                  pointerEvents: 'none'
                                }}
                              />
                            )}                
                            <small className="fLight">Não aceitamos cartões virtuais de uso único.</small>
                          </div>
                        </Grid>

                        <Grid item xs={12} sm={6}>
                          {/* Nome */}
                          <div className="field" style={{ marginBottom:"0.5rem",flex: 1 }}>
                            <label>Nome impresso no cartão <span className="requiredField">*</span></label>
                            <InputText
                              value={form.cardHolderName}
                              onChange={(e) => handleField('cardHolderName', e.target.value)}
                              placeholder="Nome como impresso no cartão"
                              disabled={loading}
                              className="w100"
                            />
                          </div>
                        </Grid>              

                        <Grid item xs={12} sm={6}>
                          <div style={{  marginBottom:"0.5rem",flex:1 }}>
                            <label>Validade <span className="requiredField">*</span></label>
                            <InputText
                              value={form.cardExpiry}
                              onChange={(e) => {
                                const masked = maskCardExpiry(e.target.value);
                                handleField('cardExpiry', masked.value);
                              }}
                              placeholder="MM/AA"
                              maxLength={5}
                              disabled={loading}
                              className="w100"
                            />
                          </div>
                        </Grid>

                        <Grid item xs={12} sm={6}>
                          <div style={{ marginBottom:"0.5rem",flex:1 }}>
                            <label>CVV <span className="requiredField">*</span></label>
                            <InputText
                              value={form.cardCvv}
                              onChange={(e) => handleField('cardCvv', e.target.value)}
                              maxLength={form.cardBrand === 'amex' ? 4 : 3}
                              placeholder="CVV"
                              disabled={loading}
                              className="w100"
                            />
                          </div>
                        </Grid>                

                        <Grid item xs={12} sm={6}>
                          {/* Parcelas */}
                          <div className="field" style={{flex:1 }}>
                            <label>Parcelamento <span className="requiredField">*</span></label>
                            <Dropdown
                              value={form.installments}
                              options={installmentsOptions}
                              optionLabel="label"
                              optionValue="value"
                              onChange={(e) => {
                                const opt = installmentsOptions.find(o => o.value === e.value);
                                handleField('installments', e.value);
                                handleField('installmentsLabel', opt?.label || null);
                              }}
                              disabled={loading}
                              placeholder="Selecione..."
                              className="w100"
                            />
                          </div>
                        </Grid>

                        <Grid item xs={12} sm={6}>
                          {/* CPF (se brasileiro) */}
                          {payer?.isForeigner !== true && (
                          <div className="field" style={{flex:1 }}>
                            <label>CPF do portador <span className="requiredField">*</span></label>
                            <InputText
                              value={payerCPF ? maskCPF(payerCPF) : form.cardHolderCpf}
                              onChange={(e) => handleField('cardHolderCpf', maskCPF(e.target.value))}
                              readOnly={!!payerCPF}
                              placeholder="000.000.000-00"
                              disabled={loading}
                              className="w100"
                            />
                            {payerCPF && <small>Preenchimento automático a partir do responsável.</small>}
                          </div>
                          )}
                        </Grid>     

                      </Grid>
                    </TabPanel>

                    <TabPanel header="PIX (em breve)" disabled>
                      <div style={{ color: '#777' }}>Em breve…</div>
                    </TabPanel>
                  </TabView>

                  {/* rodapé simples */}
                  {/*<div style={{ display: 'flex', gap: 8, justifyContent: 'flex-end', marginTop: 8 }}>
                    <Button
                      label={loading ? 'Processando...' : 'Confirmar pagamento'}
                      icon={loading ? 'pi pi-spin pi-spinner' : 'pi pi-check'}
                      onClick={handlePay}
                      disabled={loading || !form.cardNumber || !form.cardHolderName || !form.cardExpiry || !form.cardCvv || (payer?.isForeigner !== true && !form.cardHolderCpf) || !form.installments}
                      style={{ maxWidth: "50%" }}
                    />
                  </div>*/}
                </div>
                <Toast ref={toast} position="bottom-center" />	
                                
              </div>                                                            

            </div>					  

          </>	
        }

      </Box>

      <Toast ref={toast} position="bottom-center" />			

    </Dialog>	
  </>	
);
}


const mapStateToProps = store => ({
  dialog:store.appReducer.dialog,
  selectedReservation:store.reservationReducer.selectedReservation,
  masterUser:store.appReducer.masterUser
});
const mapDispatchToProps = dispatch => bindActionCreators({ ...AppActions, ...ReservationActions, ...OrderActions }, dispatch);

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ReservationMuliPayView);
